import { getLanguageCode } from "./language";

const collatorCache = new Map<string, Intl.Collator>();

const getNaturalCollator = (language?: string) => {
  const locale = getLanguageCode(language);
  const cached = collatorCache.get(locale);
  if (cached) return cached;

  const collator = new Intl.Collator(locale, {
    numeric: true,
    sensitivity: "base",
  });
  collatorCache.set(locale, collator);
  return collator;
};

export const getNaturalSortComparator = (language?: string) => {
  return getNaturalCollator(language).compare;
};
